import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import { useState } from 'react';
import UISideNavItem from 'UIComponents/nav/UISideNavItem';
import { useAddToPlaylistOptionList, CreatePlaylistLink, AddToPlaylist } from '../../savedItems';
import styled from 'styled-components';
import HR from 'UIComponents/elements/HR';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { FormattedMessage } from '../../../components/I18n';
import { CardMenu, CardMenuFooterLink, CardMenuHeader } from '../../cardMenu';
const RowSpinner = styled(UILoadingSpinner).withConfig({
  displayName: "CardMenuAddToPlaylistOption__RowSpinner",
  componentId: "sc-1mbznyt-0"
})(["position:absolute;right:10px;"]);

const useIsLoadingFirstPlaylistsPage = isOpen => {
  const {
    playlistsLoading
  } = useAddToPlaylistOptionList({
    skip: !isOpen
  });
  return playlistsLoading;
};

const CardMenuAddToPlaylistOption = ({
  trackId,
  lessonId,
  language,
  onPlaylistClick,
  onCreatePlaylistClick
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOnOpenChange = e => setIsOpen(e.target.value);

  const handleAddToPlaylistsClick = () => setIsOpen(true);

  const isLoadingFirstPlaylistsPage = useIsLoadingFirstPlaylistsPage(isOpen);
  return /*#__PURE__*/_jsx(CardMenu, {
    content: {
      header: /*#__PURE__*/_jsx(CardMenuHeader, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyNav.heading.myPlaylists"
        })
      }),
      body: /*#__PURE__*/_jsx(AddToPlaylist, {
        language: language,
        lessonId: lessonId,
        onPlaylistClick: onPlaylistClick,
        trackId: trackId
      }),
      footer: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HR, {
          distance: "flush"
        }), /*#__PURE__*/_jsx(CreatePlaylistLink, {
          language: language,
          lessonId: lessonId,
          render: (content, to) => /*#__PURE__*/_jsx(CardMenuFooterLink, {
            onClick: onCreatePlaylistClick,
            to: to,
            children: content
          }),
          trackId: trackId,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.cardMenu.addToNewPlaylist"
          })
        })]
      })
    },
    onOpenChange: handleOnOpenChange,
    open: isOpen && !isLoadingFirstPlaylistsPage,
    placement: "right bottom",
    children: /*#__PURE__*/_jsx(UISideNavItem, {
      "data-test-id": "add-to-playlist-button",
      iconRight: isLoadingFirstPlaylistsPage ? /*#__PURE__*/_jsx(RowSpinner, {
        size: "extra-small"
      }) : 'right',
      onClick: handleAddToPlaylistsClick,
      title: I18n.text('learningCenter.cardMenu.addToPlaylist')
    })
  });
};

export default CardMenuAddToPlaylistOption;